import ApiService from "./ApiService";
import appConfig from "configs/app.config";

export async function apiSignIn(data, alert) {
  return ApiService.fetchData(
    {
      url: `/sign-in`,
      method: "post",
      data,
    },
    alert
  );
}

export async function apiSignUp(data, alert) {
  return ApiService.fetchData(
    {
      url: "/sign-up",
      method: "post",
      data,
    },
    alert
  );
}

export async function apiSignOut(data, alert) {
  localStorage.removeItem("token");
  /*return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })*/
}

export async function apiForgotPassword(data, alert) {
  return ApiService.fetchData(
    {
      url: `/password/forgot?emailAddress=` + data.emailAddress,
      method: "post",
      data,
    },
    alert
  );
}

export async function apiResetPassword(data, alert) {
  return ApiService.fetchData(
    {
      url: "/password/reset?token=" + data.token + "&password=" + data.password,
      method: "post",
      data,
    },
    alert
  );
}
